/**
 * Created by user on 2020/5/29.
 */

import tableTw2CnDebugTable from './table_tw2cn.debug.safe.json';
import { ITable } from '../types';

export = tableTw2CnDebugTable as any as ITable
